import React from 'react';
import Paper from "@material-ui/core/Paper/Paper";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import i18n from "../../i18n";
import {withStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid/Grid";
import {FormattedNumber} from "react-intl";
import Typography from "@material-ui/core/Typography/Typography";
import Divider from "@material-ui/core/Divider/Divider";
import Icon from "@material-ui/core/Icon/Icon";
import Button from "@material-ui/core/Button/Button";
import EllipisWithTooltip from "../Formater/EllipsisWithTooltip";
import FormaterDate from "../Formater/Date";

const renderDetailsRow = (label, value, classes) => {
    return (
        <ListItem key={Math.random()} dense className={classes.detailsRow}>
            <Grid container spacing={24}>
                <Grid item xs={4}>
                    <Typography className={classes.detailsLabel} component={"div"}
                                variant={"subtitle2"}>{(<EllipisWithTooltip>{label}</EllipisWithTooltip>)}</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography className={classes.detailsValue} component={"div"}
                                variant={"body2"}>{value}</Typography>
                </Grid>
            </Grid>
        </ListItem>
    );
};

const renderBoardDetails = (positions, classes) => {
    return (
        <List className={classes.fullWidth}>
            <ListItem key={Math.random()} dense className={classes.detailsRow}>
                <Grid container spacing={24}>
                    <Grid item xs={4}>
                        <Typography className={classes.detailsLeft} component={"div"}
                                    variant={"subtitle2"}>{(<EllipisWithTooltip>Rechnungsposition</EllipisWithTooltip>)}</Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography className={classes.detailsRight} component={"div"}
                                    variant={"subtitle2"}>Auszubildende/r</Typography>
                    </Grid>
                </Grid>
            </ListItem>
            {positions.map((position, keyID) => (
                <ListItem key={position.student_id} dense className={classes.detailsRow}>
                    <Grid container spacing={24}>
                        <Grid item xs={4}>
                            <Typography className={classes.detailsLeft} component={"div"}
                                        variant={"body2"}>{(<EllipisWithTooltip>{keyID+1}</EllipisWithTooltip>)}</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography className={classes.detailsRight} component={"div"}
                                        variant={"body2"}>{position.first_name + ' ' + position.last_name}</Typography>
                        </Grid>
                    </Grid>
                </ListItem>
            ))}
        </List>
    );
};

const renderPersonDetails = (positions, classes) => {
    return (
        <List className={classes.fullWidth}>
            <ListItem key={Math.random()} dense className={classes.detailsRow}>
                <Grid container spacing={24}>
                    <Grid item xs={4}>
                        <Typography className={classes.detailsLeft} component={"div"}
                                    variant={"subtitle2"}>{(<EllipisWithTooltip>Tag</EllipisWithTooltip>)}</Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography className={classes.detailsMiddle} component={"div"}
                                    variant={"subtitle2"}>Anzahl Unterrichtseinheiten</Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography className={classes.detailsRight} component={"div"}
                                    variant={"subtitle2"}>Bezahlung pro Tag</Typography>
                    </Grid>
                </Grid>
            </ListItem>
            {positions.map(position => (
                <ListItem key={Math.random()} dense className={classes.detailsRow}>
                    <Grid container spacing={24}>
                        <Grid item xs={4}>
                            <Typography className={classes.detailsLeft} component={"div"}
                                        variant={"subtitle2"}>{(<EllipisWithTooltip>{position.day}</EllipisWithTooltip>)}</Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography className={classes.detailsMiddle} component={"div"}
                                        variant={"body2"}>{position.count}</Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography className={classes.detailsRight} component={"div"}
                                        variant={"body2"}><FormattedNumber value={position.payment} style={"currency"} currency={"EUR"}/></Typography>
                        </Grid>
                    </Grid>
                </ListItem>
            ))}
        </List>
    );
};

class InvoiceCosts extends React.Component {
    render() {
        const {invoice, invoice_type, classes, short} = this.props;

        return invoice && (
            <Paper className={classes.spaces}>
                <Typography component={"h6"} variant={"h6"}>
                    {i18n.get('invoice.billed_items', invoice)}
                </Typography>
                <div className={classes.details}>
                    {invoice_type === 'board' && renderBoardDetails(invoice.positions, classes)}
                    {invoice_type === 'person' && renderPersonDetails(invoice.positions, classes)}
                </div>
                {short && (
                    <Button
                        variant="outlined" color="primary"
                        component="a"
                        href={`/invoice/${invoice.id}`}
                    >
                        {i18n.get('invoice.full_view')}
                        <Icon>find_in_page</Icon>
                    </Button>
                )}
            </Paper>
        )
    }
}

const styles = theme => ({
    spaces: {
        padding: theme.spacing.unit * 1.5,
    },
    fullWidth: {
        width: "100%",
    },
    details: {
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
        "&:last-child": {
            padding: 0,
        }
    },
    detailsLeft: {
        textAlign: "right",
    },
    detailsMiddle: {
        textAlign: "center",
        "& > *": {
            ...theme.helpers.oneLiner,
        },
    },
    detailsRight: {
        "& > *": {
            ...theme.helpers.oneLiner,
        },
    },
    inlineSpan: {
        display: 'inline',
    },
});


export default withStyles(styles)(InvoiceCosts);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Invoice/InvoiceCosts.jsx